const car = [
    { id: 1,  name: 'Corolla', price: '$25,000' },
    { id: 2,  name: 'Civic', price: '$23,500' },
    { id: 3,  name: 'Mustang', price: '$35,000' },
    // Agrega más autos según sea necesario
  ];
  
  export default car;
  